import { Level2, Level3 } from '../StyledOl';

const Audit = () => (
  <li>
    AUDIT
    <Level2>
      <li>
        LINK shall, during the term of this Purchase Order and for the 12 months after the full
        performance of this Purchase Order, be entitled to audit and/or investigate:
        <Level3>
          <li>the Contractor&rsquo;s compliance of its obligations under the Purchase Order;</li>
          <li>
            the validity of the Contractor&rsquo;s certifications, service marks and/or trust marks;
          </li>
          <li>
            the Contractor for any suspected unauthorized leakage of information that was provided
            by, or on behalf of, LINK to the Contractor (including but not limited to Personal Data)
            that may be linked to the Contractor;
          </li>
          <li>
            the Contractor to verify any representations made by the Contractor to LINK in respect
            of the Contractor&rsquo;s capabilities to perform the Contractor&rsquo;s obligations
            under the Purchase Order;
          </li>
          <li>
            the cyber security measures put in place by the Contractor and their corresponding
            robustness for the purposes of assessing that the Contractor has implemented sufficient
            cyber security measures; and
          </li>
          <li>
            the Contractor in accordance with any audit plan as may be set out in the Purchase Order
            or as may be mutually agreed between the Parties.
          </li>
        </Level3>
      </li>
      <li>
        The Contractor shall render, and shall procure that its respective officers, directors,
        employees, representatives, contractors or agents render, full cooperation to and provide
        full access to all relevant information, documents, records, premises, furnishing (including
        lockable cabinets), and information technology systems within the deadlines required by LINK
        to LINK&rsquo;s appointed representatives in such audit or investigation. The Contractor
        shall provide access to and the use of the Contractor&rsquo;s telephone, facsimile services,
        utilities, office-related equipment, and duplicating services as LINK&rsquo;s appointed
        representatives may reasonably require to perform such audit and/or investigation.
      </li>
      <li>
        LINK will reasonably endeavor to conduct the audit in a manner that does not unduly disrupt
        the Contractor&rsquo;s operations.
      </li>
    </Level2>
  </li>
);

export default Audit;
